import {
  ChartLineIcon,
  CheckListIcon,
  DevicesIcon,
  DocSearchIcon,
  FinancingIcon,
  HalfDataIcon,
  JoyStickIcon,
  ListViewIcon,
  MapIcon,
  RemoteControlIcon,
  TableReportIcon,
  UserIcon,
} from '@/components/icons'
import EditCalendar from '@/components/icons/EditCalendar'
import LayersIcon from '@/components/icons/LayersIcon'
import MoreAppIcon from '@/components/icons/MoreAppIcon'
import PageTemplateIcon from '@/components/icons/PageTemplateIcon'
import TreeListIcon from '@/components/icons/TreeListIcon'
import { CONFIG_ROUTES, OPERATIONS_ROUTES } from '@/constant/route'

import { useAuthContext } from '@features/auth/context'
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined'

import {
  DigitalTwinAccess,
  DynamicDashboardAccess,
  ZeusDashboardAccess,
} from 'constant/featureAccessRestriction'

export const getMenuMain = (
  t: (key: string) => string,
  interfaceId?: number,
) => [
  {
    link: OPERATIONS_ROUTES.mapview.to,
    icon: <MapIcon />,
    label: t('menuOperationsMapView'),
    disabled: false,
  },
  // Only controllers with a twin get the entry
  ...(interfaceId && DigitalTwinAccess.includes(interfaceId)
    ? [
        {
          link: OPERATIONS_ROUTES.digitalTwin.to,
          icon: <ViewInArOutlinedIcon sx={{ fontSize: 20 }} />,
          label: t('menuOperationsDigitalTwin'),
          disabled: false,
        },
      ]
    : []),
  {
    link: OPERATIONS_ROUTES.programs.to,
    icon: <ListViewIcon />,
    label: t('menuOperationsPrograms'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.dynamicDashboard.to,
    icon: <ListViewIcon />,
    label: t('menuOperationsDynamicDashboard'),
    disabled: interfaceId ? !DynamicDashboardAccess.includes(interfaceId) : true,
  },
  {
    link: OPERATIONS_ROUTES.irrigationOverview.to,
    icon: <TableReportIcon />,
    label: t('menuOperationsIrrigationOverview'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.programSchedule.to,
    icon: <EditCalendar fill="#8A8A8A" />,
    label: t('menuOperationsProgramSchedule'),
    disabled: true,
  },

  {
    link: OPERATIONS_ROUTES.manualRun.to,
    icon: <JoyStickIcon />,
    label: t('menuOperationsManualRun'),
    disabled: true,
  },
  {
    link: OPERATIONS_ROUTES.simulation.to,
    icon: <ChartLineIcon />,
    label: t('menuOperationsSimulation'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.flowHistory.to,
    icon: <TreeListIcon />,
    label: t('menuOperationsFlowHistory'),
    disabled: false,
  },
  // {
  //   link: OPERATIONS_ROUTES.stations.to,
  //   icon: <DevicesIcon />,
  //   label: ' Stations',
  //   disabled: false,
  // },

  {
    link: OPERATIONS_ROUTES.sensors.to,
    icon: <MoreAppIcon />,
    label: t('menuOperationsSpecialOperations'),
    disabled: true,
  },
]
// Pure function: safe to call anywhere
export const getMenuSensors = (
  t: (key: string) => string,
  interfaceId?: number,
) => {
  const shouldShowZeusDashboard = interfaceId
    ? ZeusDashboardAccess.includes(interfaceId)
    : false

  const menu = []

  menu.push({
    link: OPERATIONS_ROUTES.sensors.to,
    icon: <PageTemplateIcon />,
    label: t('menuSensorsSensorsDashboard'),
    disabled: false,
  })
  shouldShowZeusDashboard &&
    menu.push({
      link: OPERATIONS_ROUTES.zeusDashboard.to,
      icon: <PageTemplateIcon />,
      label: t('menu.parklandDashboard'),
      disabled: false,
    })
  menu.push({
    link: CONFIG_ROUTES.etz.to,
    icon: <FinancingIcon />,
    label: t('menuSensorsMicroClimate'),
    disabled: false,
  })
  return menu
}

export const getMenuStationConfig = (t: (key: string) => string) => [
  {
    link: CONFIG_ROUTES.stations.to,
    icon: <DevicesIcon />,
    label: t('menuStationConfigStations'),
    disabled: false,
  },
  {
    link: CONFIG_ROUTES.controllers.to,
    icon: <RemoteControlIcon />,
    label: t('menuStationConfigDecoders'),
    disabled: false,
  },
  {
    link: CONFIG_ROUTES.areasAndZones.to,
    icon: <LayersIcon />,
    label: t('menuStationConfigAreasSubAreas'),
    disabled: false,
  },
]

export const getMenuDataConfig = (t: (key: string) => string) => [
  {
    link: CONFIG_ROUTES.dataConfig.to,
    icon: <HalfDataIcon />,
    label: t('menuDataConfigDataConfiguration'),
    disabled: false,
  },
]

export const getMenuOther = (t: (key: string) => string) => [
  {
    link: OPERATIONS_ROUTES.diagnostics.to,
    icon: <CheckListIcon />,
    label: t('menuOtherDiagnosis'),
    disabled: false,
  },
  // {
  //   link: OPERATIONS_ROUTES.activities.to,
  //   icon: <WorkBenchIcon />,
  //   label: ' Activity',
  //   disabled: false,
  // },
  {
    link: OPERATIONS_ROUTES.reports.to,
    icon: <DocSearchIcon />,
    label: t('menuOtherReports'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.userManagement.to,
    icon: <UserIcon />,
    label: t('menuOtherUserManagement'),
    disabled: true,
  },
]
